export default () => ({
  asteriskServer: {
    form: null,
    work: 'si'
  },
  jitsiServer: {
    form: null
  },
  jitsiServersList: []
})